import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router";
import { ROUTES } from '../../../../constant/routeConstant';
import { deletePallet, editPallet, getDetailPallet, getListPallet, getSearchRecommendation, postPallet, getSearchResult, initiatePallet, getListPalletDropdown, getManagementHistoryList } from '../../../../service/master/Pallet/PalletService';
import moment from 'moment';

export const usePallet = () => {
    const { token, grolog_account_id, userId } = useSelector((state) => state.auth);

    let fixedParam = `RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

    const [list, setList] = useState([])
    const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false)
    const [successModalOpen, setSuccessModalOpen] = useState(false)

    const [options, setOptions] = useState([])
    const [searchKeyword, setSearchKeyword] = useState()

    const [showConfirm, setShowConfirm] = useState(false)

    const [selectedId, setSelectedId] = useState()
    const [selectedUpdatedAt, setSelectedUpdatedAt] = useState()
    const [selectedPalletName, setSelectedPalletName] = useState()

    const [palletName, setPalletName] = useState('')
    const [palletDescription, setPalletDescription] = useState('')
    const [weight, setWeight] = useState(0)
    const [length, setLength] = useState(0)
    const [height, setHeight] = useState(0)
    const [width, setWidth] = useState(0)

    const [selectedDepotId, setSelectedDepotId] = useState()
    const [listDropdown, setListDropdown] = useState([])

    const [palletNameError, setPalletNameError] = useState(false)
    const [palletDescriptionError, setPalletDescriptionError] = useState(false)
    const [palletWeightError, setPalletWeightError] = useState(false)
    const [palletLengthError, setPalletLengthError] = useState(false)
    const [palletHeightError, setPalletHeightError] = useState(false)
    const [palletWidthError, setPalletWidthError] = useState(false)

    const [dataToCompare, setDataToCompare] = useState()

    const [totalData, setTotalData] = useState()

    const [detailPallet, setDetailPallet] = useState()

    const [sorting, setSorting] = useState(`id asc`)

    const [pageLimit, setPageLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [statePageSize, setStatePageSize] = useState(10)

    const [currentPage, setCurrentPage] = useState(1)

    const [managementHistoryList, setManagementHistoryList] = useState([])

    const navigate = useNavigate();

    const [dropdownListLoading, setDropdownListLoading] = useState(false)
    const [depotKeyword, setDepotKeyword] = useState('')
    const [depotListPage, setDepotListPage] = useState(1)

    const setEditedData = (data) => {
        setPalletName(data.pallet_name)
        setPalletDescription(data.description)
        setWeight(data.weight)
        setLength(data.length)
        setHeight(data.height)
        setWidth(data.width)
        setDataToCompare(data)
    }

    const doSort = (sort) => {
        setSorting(sort);
        doGetPalletList(1, 10, selectedDepotId, sort);
    }

    const toAddPallet = () => {
        navigate("/master/fleet/pallet/add", {
            state: {
                depotId: selectedDepotId
            }
        })
    }

    const toEditPallet = (data) => {
        navigate(ROUTES.PALLET.EDIT, {
            state: {
                data
            }
        })
    }

    const toDetailPallet = (id) => {
        navigate(ROUTES.PALLET.DETAIL, {
            state: {
                id
            }
        })
    }

    const onScroll = (event, namespace) => {
        let target = event.target
        switch (namespace) {
            case 'depotList':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    doGetListDropdown(depotListPage + 1, depotKeyword)
                    setDepotListPage(depotListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;

            default:
                break;
        }
    }

    const onSearchDDS = (keyword, namespace) => {
        switch (namespace) {
            case 'depotList':
                setDepotKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    doGetListDropdown(1, keyword, 'searchList')
                }
                setDepotListPage(1)
                break;

            default:
                break;
        }
    }

    const toListPallet = () => {
        setPalletName()
        setPalletDescription()
        setLength()
        setWidth()
        setHeight()
        setWeight()
        navigate(ROUTES.PALLET.LIST)
    }

    function deleteData(id, updated_at, name) {
        setSelectedPalletName(name)
        setSelectedId(id)
        setSelectedUpdatedAt(updated_at)
        setDeleteConfirmationModalOpen(true)
    }

    const dispatch = useDispatch();

    const onSearch = (event) => {
        setSearchKeyword(event.target.value)
        doSearch(searchKeyword)
    }

    const handlePagination = (page, pageSize, selectedDepotId) => {
        doInitializePallet(page, pageSize, searchKeyword, selectedDepotId)
        doGetPalletList(page, pageSize, selectedDepotId)
    }

    const doInitializePallet = async (page, pageSize, keyword, id) => {
        const param = `page=${page}&limit=${pageSize}&filter=depot_id eq ${id}${keyword ? `, pallet_name lk ${keyword}` : ''}`
        try {
            const response = await initiatePallet(token, null, param, dispatch)
            if (response && response.ok) {
                setTotalData(response.data.count_data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetManagementHistoryList = async (id) => {
        try {
            const response = await getManagementHistoryList(token, null, dispatch, id);
            if (response && response.ok) {
                const data = response.data
                const reorderedData = []

                for (let i = data.length - 1; i >= 0; i--) {
                    const element = data[i];
                    reorderedData.push(element)
                }

                setManagementHistoryList(reorderedData)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetPalletList = async (page, pageLimit, id, sort) => {

        const param = `page=${page}&limit=${pageLimit}&order=${sort ? sort : `id asc`}`

        try {
            const response = await getListPallet(token, null, param, id, fixedParam, dispatch)
            if (response && response.ok) {
                setList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doPostPallet = async (depot_id) => {
        if (checkForm()) {
            let data = {
                'depot_id': depot_id,
                'pallet_name': palletName,
                'description': palletDescription,
                'length': length,
                'width': width,
                'height': height,
                'weight': weight
            }

            try {
                const response = await postPallet(token, null, data, dispatch)
                if (response && response.ok) {
                    setSuccessModalOpen(true)
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    const doEditPallet = async (data) => {
        if (checkForm()) {
            const updatedData = {
                "depot_id": data.depot_id,
                "pallet_name": palletName,
                "description": palletDescription,
                "weight": weight,
                "length": length,
                "height": height,
                "width": width,
                "updated_at": data.updated_at
            }
            try {
                const response = await editPallet(token, null, data.pallet_id, updatedData, dispatch)
                if (response && response.ok) {
                    setSuccessModalOpen(true)
                    setSelectedId()
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    const deleteConfirmation = (id, updated_at, name) => {
        setDeleteConfirmationModalOpen(true)
        setSelectedId(id)
        setSelectedUpdatedAt(updated_at)
        setSelectedPalletName(name)
    }

    const doGetDetailPallet = async (id) => {
        try {
            const response = await getDetailPallet(token, null, id, dispatch);
            if (response && response.ok) {
                setDetailPallet(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doDeletePallet = async () => {
        try {
            const response = await deletePallet(token, null, selectedId, selectedUpdatedAt, dispatch)
            if (response && response.ok) {
                setDeleteConfirmationModalOpen(false)
                setSuccessModalOpen(true)
                setSelectedId()
                setSelectedUpdatedAt()
                setSelectedPalletName()
                doGetPalletList(1, 10, selectedDepotId)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doSearch = async (keyword) => {
        try {
            const response = await getSearchRecommendation(token, null, selectedDepotId, keyword, dispatch);
            if (response && response.ok) {
                setOptions(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const onSelect = async (keyword) => {
        try {
            const response = await getSearchResult(token, null, selectedDepotId, keyword, dispatch);
            if (response && response.ok) {
                doInitializePallet(page, pageLimit, keyword, selectedDepotId)
                setList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const checkForm = () => {
        if (palletName !== '' && palletDescription !== '' && weight !== 0 && length !== 0 && height !== 0 && width !== 0) {
            return true
        } else {
            if (palletName === '') {
                setPalletNameError(true)
            }
            if (palletDescription === '') {
                setPalletDescriptionError(true)
            }
            if (weight === 0) {
                setPalletWeightError(true)
            }
            if (length === 0) {
                setPalletLengthError(true)
            }
            if (height === 0) {
                setPalletHeightError(true)
            }
            if (width === 0) {
                setPalletWidthError(true)
            }
            return false
        }
    }

    const onChange = (event, namespace) => {
        switch (namespace) {
            case 'pallet_name':
                if (event.target.value !== null) {
                    setPalletNameError(false)
                    setPalletName(event.target.value)
                } else {
                    setPalletNameError(true)
                }
                break;
            case 'pallet_description':
                if (event.target.value !== null) {
                    setPalletDescriptionError(false)
                    setPalletDescription(event.target.value)
                } else {
                    setPalletDescriptionError(true)
                }
                break;
            case 'weight':
                if (event !== null) {
                    setPalletWeightError(false)
                    setWeight(event)
                } else {
                    setPalletWeightError(true)
                }
                break;
            case 'width':
                if (event !== null) {
                    setPalletWidthError(false)
                    setWidth(event)
                } else {
                    setPalletWidthError(true)
                }
                break;
            case 'length':
                if (event !== null) {
                    setPalletLengthError(false)
                    setLength(event)
                } else {
                    setPalletLengthError(true)
                }
                break;
            case 'height':
                if (event !== null) {
                    setPalletHeightError(false)
                    setHeight(event)
                } else {
                    setPalletHeightError(true)
                }
                break;
            default:
                break;
        }
    }

    const isClear = () => {
        if (palletName || palletDescription || weight || width || length || height) {
            return false
        } else {
            return true
        }
    }

    const isEdited = () => {
        if ((palletName !== dataToCompare?.pallet_name) || (palletDescription !== dataToCompare?.description) || (weight !== dataToCompare?.weight) || (length !== dataToCompare?.length) || (height !== dataToCompare?.height)) {
            return true
        } else {
            return false
        }
    }

    const selectDepotId = async (id, page, pageLimit) => {
        setSelectedDepotId(id)
        setStatePageSize(10)
        handleChangeLimit(page, pageLimit, id)
    }

    const handleChangeLimit = (page, value, selectedDepotId) => {
        setStatePageSize(value)
        setCurrentPage(page)
        handlePagination(page, value, selectedDepotId)
    }

    const doClear = (depot_id) => {
        setSearchKeyword()
        setOptions([])
        doInitializePallet(1, 10, '', depot_id)
        doGetPalletList(1, 10, depot_id)
    }

    const doGetListDropdown = async (page, keyword = '', flags = 'list') => {
        setDropdownListLoading(true)
        try {
            const response = await getListPalletDropdown(token, page, keyword, null, dispatch);
            if (response && response.ok) {
                let option = [];
                if (response.data !== null && response.data.length !== undefined) {
                  for (let i = 0; i < response.data.length; i++) {
                    const element = response.data[i];
                    let data = {
                      id: element.depot_id,
                      value: element.depot_name,
                    };
                    option.push(data);
                  }
                }
                if (flags === "list") {
                  if (listDropdown.length === 0) {
                    setListDropdown(option);
                  } else {
                    let tempListDropdown = [...listDropdown];
                    option.map((item) => tempListDropdown.push(item));
                    setListDropdown(tempListDropdown);
                  }
                //   setDropdownListloading(false);
                } else if (flags === "searchList") {
                  setListDropdown(option);
                }
              }
        } catch (error) {
            console.log(error)
        }
    }

    const convertTimestamp = (timestamp, isSpecific) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthNumbers = ["01", "02", "03", "04", "05", "06",
            "07", "08", "09", "10", "11", "12"
        ];

        // Extract components from the timestamp string
        const year = timestamp?.substring(0, 4);
        const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
        const day = timestamp?.substring(8, 10);

        let dateFormat = new Date(year, month, day);

        if (isSpecific) {
            return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
        } else {
            return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
        }
    }

    const convertToTime = (timestamp) => {
        let time = new Date(timestamp);
        return (moment(timestamp).utc().format('HH:mm'))
    }

    useEffect(() => {
        doGetListDropdown(depotListPage)

        // eslint-disable-next-line
    }, [])

    // useEffect(() => {
    //     doInitializePallet(1, 10, '', selectedDepotId)
    //     doGetPalletList(1, 10, selectedDepotId)
    // }, [selectedDepotId])
    
  useEffect(() => {
    if (!selectedDepotId && listDropdown?.length > 0) {
      doInitializePallet( 1, 10, '',listDropdown[0]?.id);
      doGetPalletList(1, 10, listDropdown[0]?.id);
      setSelectedDepotId(listDropdown[0]);
    //   setIsLoaded(true);
    }
  }, [listDropdown]);

    return {
        list,
        doGetPalletList,
        deleteConfirmationModalOpen,
        setDeleteConfirmationModalOpen,
        successModalOpen,
        setSuccessModalOpen,
        toAddPallet,
        toDetailPallet,
        toEditPallet,
        deleteData,
        toListPallet,
        onChange,
        palletName,
        doPostPallet,
        deleteConfirmation,
        doDeletePallet,
        selectedId,
        selectedPalletName,
        setEditedData,
        doEditPallet,
        doGetDetailPallet,
        detailPallet,
        convertTimestamp,
        convertToTime,
        onSearch,
        options,
        onSelect,
        searchKeyword,
        handlePagination,
        totalData,
        showConfirm,
        setShowConfirm,
        isClear,
        isEdited,
        palletNameError,
        palletDescriptionError,
        palletWeightError,
        selectedDepotId,
        listDropdown,
        selectDepotId,
        sorting,
        doSort,
        statePageSize,
        setStatePageSize,
        handleChangeLimit,
        doClear,
        doGetManagementHistoryList,
        managementHistoryList,
        palletLengthError,
        setPalletLengthError,
        palletHeightError,
        setPalletHeightError,
        palletWidthError,
        setPalletWidthError,
        currentPage,
        onScroll,
        onSearchDDS,
        dropdownListLoading,
        depotKeyword
    }
}